import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useContext,
  useState,
} from 'react';

import 'react-organogram/dist/index.css';
import { getPageInformation, getPageFiles } from '../../core/services/page';
import { getMenuItems, getSubMenuItems } from '../../core/services/menu';
import { useParams } from 'react-router';
import { NavLink, Link } from 'react-router-dom';
import { getLabels } from '../../core/services/label';

import { Organogram } from 'https://cdn.skypack.dev/react-organogram';
import 'react-organogram/dist/index.css';

import { AppContext } from '../../core/Contexts/AppContext';

const DynamicPage = () => {
  const { setTitle, setHeaderType, setImage } = useContext(AppContext);
  const [error, setError] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const lists = [
    {
      title: '',
      description: 'სააგენტოს უფროსი',
      id: 155,
      image: '',
      children: [],
    },
    {
      title: '',
      description: 'უფროსის მოადგილე',
      id: 157,
      image: '',
      children: [
        {
          title: '',
          description:
            'ინდუსტრიულ და სამშენებლო პროდუქტებზე ზედამხედველობის დეპარტამენტის უფროსი',
          id: 161,
          image: '',
          children: [],
        },
        {
          title: '',
          description:
            'სამომხმარებლო პროდუქტებზე ზედამხედველობის დეპარტამენტის უფროსი',
          image: '',
          id: 159,
          children: [],
        },
        {
          title: '',
          description: 'ადმინისტრაციული დეპარტამენტის უფროსი',
          image: '',
          id: 169,
          children: [],
        },
        {
          title: '',
          description: 'სამართლებრივი უზრუნველყოდის დეპარტამენტის უფროსი',
          image: '',
          id: 165,
          children: [],
        },
      ],
    },
  ];

  const params = useParams();
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [menus, setMenus] = useState([]);
  const [pageInfo, setPageInfo] = useState(null);
  const [pageFiles, setPageFiles] = useState([]);
  const [sideNav, setSideNav] = useState([]);
  const [files, setFiles] = useState([]);
  const [labelFiles, setLabelFiles] = useState([]);

  const displaySubMenus = pageInfo?.content_page?.includes('{menu}');
  const displayStructure = pageInfo?.content_page?.includes('{structure}');

  // Effect to fetch label files
  useEffect(() => {
    const fetchLabelFiles = async () => {
      try {
        const data = await getLabels();
        setLabelFiles(data || []);
      } catch (err) {
        setError('Error loading label files');
        console.error('Error fetching label files:', err);
      }
    };

    void fetchLabelFiles();
  }, []);

  // Effect to fetch and set page info
  useEffect(() => {
    const fetchPageInfo = async () => {
      try {
        if (params.menu_id) {
          const data = await getPageInformation(params.menu_id);
          setTitle(data.content_title);
          if (params.menu_id === '39') {
            setTitle('სამშენებლო პროდუქტები');
          } else {
            setTitle(data.content_title);
          }
          setHeaderType(1);
          setPageInfo(data);
        }
      } catch (err) {
        setError('Error loading page information');
        console.error('Error fetching page info:', err);
      }
    };

    const fetchPageFiles = async () => {
      try {
        if (params.menu_id) {
          const data = await getPageFiles(params.menu_id);
          setPageFiles(data || []);
        }
      } catch (err) {
        setError('Error loading page files');
        console.error('Error fetching page files:', err);
      }
    };

    const fetchSubMenuItems = async () => {
      try {
        if (params.menu_id) {
          const data = await getSubMenuItems(params.menu_id);
          setSideNav(data || []);
        }
      } catch (err) {
        setError('Error loading submenu items');
        console.error('Error fetching submenu items:', err);
      }
    };

    void fetchPageInfo();
    void fetchPageFiles();
    void fetchSubMenuItems();
  }, [params.menu_id, setTitle, setHeaderType]);

  // Effect to dynamically update the image based on content_title
  useEffect(() => {
    if (params.menu_id === '39') {
      setImage('../../images/hero-images/construction-products.jpg');
      return;
    }

    if (pageInfo?.content_title) {
      const titleImageMap = {
        'ჩვენი მისია': '../../images/safety.jpg',
        'სააგენტოს სტრუქტურა': '../../images/machinery.jpeg',
        'სასაქონლო კოდები': '../../images/hero-images/pattern-bg-optimized.jpg',
        'განაცხადე საფრთხის შემცველ პროდუქტებზე':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        'ელექტრონული განცხადების ფორმა':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        '50-ე დადგენილების შესახებ ინფორმაცია':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        'იმპორტის წინასწარი შეტყობინების შევსების ინსტრუქცია':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        'რადიო მოწყობილობები': '../../images/hero-images/radio-devices.jpeg',
        'შეცდომაში შემყვანი პროდუქტები':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        'ინდივიდუალური დაცვის საშუალებები':
          '../../images/hero-images/safety.jpg',
        'აირად საწვავზე მომუშავე მოწყობილობები':
          '../../images/hero-images/gas-banner.jpg',
        'ჩვენი მისია': '../../images/hero-images/ourmission.jpg',
        'სააგენტოს სტრუქტურა': '../../images/hero-images/hierarchy.jpg',
        'საერთაშორისო დონეზე თანამშრომლობა':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        'ადგილობრივ დონეზე თანამშრომლობა':
          '../../images/hero-images/pattern-bg-optimized.jpg',
        'მანქანა-დანადგარები': '../../images/hero-images/electric-tools.jpg',
        'ლაქ-საღებავი': '../../images/hero-images/paints.jpg',
        'წნევის ქვეშ მომუშავე მოწყობილობები':
          '../../images/hero-images/pressure-equipment.jpg',
        დებულება: '../../images/hero-images/pattern-bg-optimized.jpg',
        სანთებელები: '../../images/hero-images/lighter.jpg',
        სიახლეები: '../../images/main-hero.png',
        სათამაშოები: '../../images/hero-images/toy-banner.jpg',
        ელექტრომოწყობილობები: '../../images/hero-images/electric-devices.webp',
        ვაკანსიები: '../../images/hero-images/pattern-bg-optimized.jpg',
        ენერგოეტიკეტირება: '../../images/hero-images/label-nrg-v1.png',
      };

      setImage(
        titleImageMap[pageInfo.content_title] ||
          '../../images/hero-images/pattern-bg-optimized.jpg',
      );
    }
  }, [pageInfo?.content_title, params.menu_id, setImage]);

  useEffect(() => {
    setMenus([]);

    const fetchMenus = async () => {
      try {
        if (pageInfo?.menu_id && displaySubMenus) {
          const subMenus = await getMenuItems(pageInfo.menu_id);
          setMenus(subMenus || []);
        }
      } catch (err) {
        setError('Error loading menus');
        console.error('Error fetching menus:', err);
      }
    };

    void fetchMenus();
  }, [pageInfo, displaySubMenus]);

  const getMenuContent = useMemo(() => {
    if (!menus?.length) return null;

    return menus.map((menu) => (
      <div key={menu.menu_id}>
        <Link
          to={`../page/${menu.menu_id}`}
          className='semi-bold font__size--14 text__14-1024 btn btn__outlined--blue color__blue no__opacity rounded-2 shadow'
        >
          {menu.title}
        </Link>
        <br />
      </div>
    ));
  }, [menus]);

  const content = useMemo(() => {
    if (!pageInfo?.content_page) {
      return '';
    }

    let result = pageInfo.content_page;

    if (displaySubMenus) {
      result = pageInfo.content_page.replace('{menu}', '<div id="menu"></div>');
    }
    if (displayStructure) {
      result = pageInfo.content_page.replace('{structure}', '');
    }

    return result;
  }, [pageInfo?.content_page, displaySubMenus, displayStructure]);

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  if (error) {
    return (
      <div className='container mt-5'>
        <div className='alert alert-danger'>{error}</div>
      </div>
    );
  }

  return (
    <Fragment>
      {!pageInfo && <div className='container mt-5'>Loading...</div>}
      {pageInfo && (
        <section className='pt-25'>
          <div className='container'>
            <div className='row'>
              <div className='col-md-4 mb-4 mb-md-0'>
                <ul className='list__menu-side'>
                  {sideNav.map((link) => (
                    <li key={link.menu_id}>
                      {link.title ===
                      'შეავსე იმპორტის წინასწარი შეტყობინება' ? (
                        <a
                          href='https://eservices.rs.ge/Login.aspx?redirect_url=https://eservices.rs.ge/Login.aspx'
                          target='_blank'
                          rel='noopener noreferrer'
                          className='norma bold font__size--16 active'
                        >
                          {link.title}
                        </a>
                      ) : (
                        <NavLink
                          to={`../page/${link.menu_id}`}
                          className='norma bold font__size--16 active'
                        >
                          {link.title}
                        </NavLink>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
              <div className='col-md-8'>
                {displayStructure && (
                  <div className='custom-organogram'>
                    <Organogram
                      lists={lists.map((item) => ({
                        ...item,
                        description: (
                          <Link
                            to={`/page/${item.id}`}
                            className='description-link'
                          >
                            {item.description}
                          </Link>
                        ),
                        children: item.children.map((child) => ({
                          ...child,
                          description: (
                            <Link
                              to={`/page/${child.id}`}
                              className='description-link'
                            >
                              {child.description}
                            </Link>
                          ),
                        })),
                      }))}
                    />
                  </div>
                )}
                {getMenuContent && (
                  <div className='pg-button'>{getMenuContent}</div>
                )}
                <div
                  className='normal font__size--16 color__gray-1 bg-gray'
                  dangerouslySetInnerHTML={{ __html: content }}
                />
                {params.menu_id === '227' && (
                  <div className='accordion' id='filesAccordion'>
                    {(() => {
                      const groupedFiles = labelFiles.reduce((acc, file) => {
                        const category = file.category || 'Uncategorized';
                        if (!acc[category]) acc[category] = [];
                        acc[category].push(file);
                        return acc;
                      }, {});
                      return Object.keys(groupedFiles).length > 0 ? (
                        Object.keys(groupedFiles).map((category, index) => (
                          <div key={index} className='accordion-item mb-3'>
                            <h4 className='accordion-header'>
                              <button
                                className={`accordion-button ${
                                  activeIndex === index ? '' : 'collapsed'
                                }`}
                                type='button'
                                onClick={() => handleAccordionClick(index)}
                                aria-expanded={activeIndex === index}
                              >
                                <span>{category}</span>
                                <span
                                  className={`arrow-icon ${
                                    activeIndex === index ? 'rotate' : ''
                                  }`}
                                >
                                  ↓
                                </span>
                              </button>
                            </h4>
                            <div
                              className={`accordion-collapse collapse ${
                                activeIndex === index ? 'show' : ''
                              }`}
                            >
                              <div className='accordion-body'>
                                {groupedFiles[category].map((file, idx) => (
                                  <a
                                    key={idx}
                                    href={`${BASE_URL}/uploads/energo_label/${
                                      file.file_id
                                    }/${encodeURIComponent(file.file_name)}`}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='wrapper__list-document d-inline-block color__gray-1 my-3'
                                  >
                                    <div className='d-flex j-content-sb align-items-center'>
                                      <div className='ml-2 semi-bold font__size--14 text__14-1024 text-uppercase'>
                                        {file.description}
                                      </div>
                                      <img
                                        src='./../images/pdf (1) 1.png'
                                        alt=''
                                      />
                                    </div>
                                  </a>
                                ))}
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div>No files available</div>
                      );
                    })()}
                  </div>
                )}
                {pageInfo.content_title !== 'ენერგოეტიკეტირება' && (
                  <div>
                    {pageFiles?.map((file, index) => (
                      <div key={index}>
                        <a
                          target='_blank'
                          href={`${process.env.REACT_APP_BASE_IMAGE_LOCATION}/uploads/page_files/${file.menu_id}/${file.file_name}`}
                          rel='noreferrer'
                          className='wrapper__list-document d-inline-block color__gray-1 j-content-sb d-flex '
                        >
                          {file.name}
                          <div className='d-flex j-content-sb align-items-center'>
                            <img
                              src='./../images/pdf (1) 1.png'
                              alt=''
                              className='pl-1'
                            />
                          </div>
                        </a>
                        <br />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
    </Fragment>
  );
};

export default DynamicPage;
